import Styles from '../../2.jobPostings/styles.module.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getFirestore, onSnapshot } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import { MID_CAREER_POSITIONS, midCareerRecruitId } from '../positions';

// 中途採用(スタイリスト/アシスタント)の「求人の編集」入口一覧。
// 新卒の求人票一覧(2.jobPostings/index.tsx)の年度行と同じ考え方で、
// ポジションごとに1行表示し、編集画面(./edit/:position)へ遷移する。
// 中途採用は公開・PDF・送付先選択の仕組みと連携しないため、それらの列は持たない。

type PositionStatus = {
  title: string;
};

const MidCareerRecruit: React.FC = () => {
  const navigate = useNavigate();
  const company = useAppSelector((state) => state.company.company);
  const db = getFirestore();

  const [statusByPosition, setStatusByPosition] = useState<Record<string, PositionStatus>>({});

  useEffect(() => {
    if (!company?.id) return;

    const unsubscribes = MID_CAREER_POSITIONS.map((position) => {
      const recruitId = midCareerRecruitId(company.id, position.slug);
      return onSnapshot(doc(db, 'recruits', recruitId), (docSnap) => {
        setStatusByPosition((prev) => ({
          ...prev,
          [position.slug]: { title: docSnap.data()?.summary?.title ?? '' },
        }));
      });
    });

    return () => unsubscribes.forEach((unsub) => unsub());
  }, [company.id]);

  return (
    <div className={Styles.box}>
      <div className={Styles.recruit_table}>
        <div className={Styles.recruit_table_nav}>
          <h3 className={Styles.recruit_table_nav_year}>ポジション</h3>
          <h3 className={Styles.recruit_table_nav_title}>求人タイトル</h3>
          <h3 className={Styles.recruit_table_nav_edit}>求人の編集</h3>
        </div>

        {MID_CAREER_POSITIONS.map((position) => (
          <div key={position.slug} className={Styles.items_table}>
            <div className={Styles.items_table_box_year}>
              <h4>{position.label}</h4>
            </div>
            <div className={Styles.items_table_box_title}>
              <h4>{statusByPosition[position.slug]?.title || '未設定'}</h4>
            </div>
            <div className={Styles.items_table_box_edit}>
              <button onClick={() => navigate(`/service/midCareer/recruit/${position.slug}`)}>編集する</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MidCareerRecruit;
